import { render, staticRenderFns } from "./BillingHistory.vue?vue&type=template&id=881c267a&"
import script from "./BillingHistory.vue?vue&type=script&lang=js&"
export * from "./BillingHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports